import { ApplicationRef, ComponentRef, createComponent, DOCUMENT, inject, Injectable, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum ModalDismissReasons {
  CANCEL,
  OK,
}

export class Modal {
  params?: any;

  dismiss(reason?: any): void {}
}

export class ModalRef {
  private _dismissed = new Subject<any>();

  constructor(
    private _componentRef: ComponentRef<any>
  ) {}

  dismiss(reason?: any): void {
    const element = this._componentRef.location.nativeElement;
    element.parentNode.removeChild(element);
    this._componentRef.destroy();
    this._dismissed.next(reason);
  }

  get dismissed(): Observable<any> {
    return this._dismissed.asObservable();
  }

  get componentInstance(): any {
    return this._componentRef.instance;
  }
}

@Injectable()
export class ModalService {

  private _applicationRef = inject(ApplicationRef);
  private _document = inject(DOCUMENT);

  show(component: any, params?: any): ModalRef {
    const modal = new Modal();
    modal.params = params;

    const elementInjector = Injector.create({
      providers: [{ provide: Modal, useValue: modal }]
    });

    const environmentInjector = this._applicationRef.injector;
    const hostElement = this._document.body;
    const componentRef = createComponent(component, {environmentInjector, elementInjector});
    this._applicationRef.attachView(componentRef.hostView);
    hostElement.appendChild(componentRef.location.nativeElement);
    componentRef.changeDetectorRef.detectChanges();

    const modalRef = new ModalRef(componentRef);
    modal.dismiss = (result?: any) => {
      modalRef.dismiss(result);
    };

    return modalRef;
  }
}
